'use strict';

const GRAPH_TYPES = ['area', 'bar'];

export default class DashboardCard {
  constructor({ componentName, selectedBusinessProcessId = null, startBusinessProcessId = null }) {
    this.componentName = componentName;
    this.selectedBusinessProcessId = selectedBusinessProcessId;
    this.startBusinessProcessId = startBusinessProcessId;
  }

  set graphType(name) {
    if (!GRAPH_TYPES.includes(name)) {
      throw TypeError(`${name} is not a valid graph type.`);
    }
  }

  static get GRAPH_TYPES() {
    return GRAPH_TYPES;
  }
}
